module.exports = __webpack_public_path__ + "img/a_cp.b5251de1.png";